module.exports = __webpack_public_path__ + "static/media/fly0173.aa9f9f71.webp";